import { TrackPoint } from '../common/api/spidertracks-sdk/types/TrackData';
import { BUTTON_MODES } from '../components/Flying/Map/utils/drawing/marker';
import { UILegacyEvent } from '../types/flyingPage';

export const getLegacyStartEventForUI = (point: TrackPoint): UILegacyEvent => {
  return {
    eventName: 'First Position',
    eventDescription: 'First Position',
    eventTime: point.timestamp
  };
};

export const getLegacyEndEventForUI = (
  firstPoint: TrackPoint,
  lastPoint: TrackPoint
): UILegacyEvent => {
  return {
    eventName: 'Last Position',
    eventDescription: 'Spider Time',
    eventTime: lastPoint.timestamp,
    durationMillis: lastPoint.timestamp - firstPoint.timestamp
  };
};

export const getSpeedUpOrDownEventsForUI = (points: TrackPoint[]): UILegacyEvent[] => {
  let speedUpPoints = [];
  let speedDownPoints = [];
  const events: UILegacyEvent[] = [];

  speedUpPoints = points
    .filter(point => point.buttonMode === BUTTON_MODES.POINTS.SPEED_UP)
    .sort((a, b) => a.timestamp - b.timestamp);

  speedDownPoints = points
    .filter(point => point.buttonMode === BUTTON_MODES.POINTS.SPEED_DOWN)
    .sort((a, b) => a.timestamp - b.timestamp);

  if (speedUpPoints.length == 1) {
    events.push({
      eventName: 'Speed Up',
      eventDescription: 'Speed Up',
      eventTime: speedUpPoints[0].timestamp
    });
  }

  if (speedUpPoints.length > 1) {
    events.push({
      eventName: 'Speed Up(Origin)',
      eventDescription: 'Speed Up',
      eventTime: speedUpPoints[0].timestamp
    });
    events.push({
      eventName: 'Speed Up',
      eventDescription: 'Speed Up',
      eventTime: speedUpPoints[speedUpPoints.length - 1].timestamp
    });
  }

  if (speedDownPoints.length > 1) {
    events.push({
      eventName: 'Speed Down',
      eventDescription: 'Speed Down',
      eventTime: speedDownPoints[speedDownPoints.length - 1].timestamp
    });
  }

  return events;
};
